<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        Problem solving is a crucial part of being a software developer. One of the most valuable
        skills you can have is learning an effective problem-solving process and an action-plan for
        how to tackle a problem no matter the size.
      </p>
      <p class="mb-5">
        One such way is by breaking it down into manageable pieces. In this activity you will go
        through each problem step by step and solve them in bite size steps to help you think about
        the problem-solving process.
      </p>
      <centered-image-wrapper
        :image="image1"
        classes="2/3"
        alt="Screenshot of a page from the Minecraft escape room game: a story panel says you wake up somewhere unfamiliar, the door and windows will not open, and you notice a sign on the wall. Below it, a pixel-art wooden sign reads: You need a code to escape. Your surroundings will guide you. Back and Next buttons are underneath."
      />

      <p class="mb-5">
        <strong>Step 1:</strong> Click on the link:
        <a href="https://www.minecraftmaps.com/escape-maps" target="_blank"
          >Minecraft Escape Room</a
        >
      </p>
      <p class="mb-5"><strong>Step 2:</strong> Click ‘next’ at the bottom of the page</p>
      <p class="mb-5">
        <strong>Step 3:</strong> Go through each page and problem-solve your way out of the escape
        room
      </p>
      <p class="mb-5">
        <strong>Step 4:</strong> Once you have ‘escaped’ come out of the game don’t fill in details
        at the end.
      </p>
      <p class="mb-5"><strong>Step 5:</strong> Screen shot and upload</p>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      image1: require('@/assets/images/experiences/developer/a1_1.png'),
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
